import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Register service worker with custom handlers
serviceWorkerRegistration.register({
  onUpdate: (registration) => {
    // Check if a new service worker is waiting
    if (registration.waiting) {
      // Send a message to activate it
      navigator.serviceWorker.controller?.postMessage('SKIP_WAITING');
    }
  },
  onSuccess: (registration) => {
    console.log('Service Worker registered successfully');
  }
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
